import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbClose: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
      <g id='Box'>
        <rect fill='none' />
      </g>
      <g id='Final_icons_-_Common' data-name='Final icons - Common'>
        <path d='M16.6 7.4L15.2 6 12 9.2 8.8 6 7.4 7.4 10.6 10.6 7.4 13.8 8.8 15.2 12 12 15.2 15.2 16.6 13.8 13.4 10.6 16.6 7.4Z' />
      </g>
    </svg>
  );
};
